import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { VistaMisDepositosDependenciasInput, createVistaDepositosDependencias } from '../../models/vista-mis-depositos-dependencias.models';
import { Subscription, combineLatest } from 'rxjs';
import { selectViverosGrupoEspecieCurrentEmpresa } from '../../../../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.selectors';
import { tap } from 'rxjs/operators';
import { ViveroFormInput } from '../../../../actividades/entity-viveros-grupo-especie/models/entity-viveros-grupo-especie.models';
import { selectAllLaboratoriosFromCurrentEmpresa } from '../../../../actividades/entity-laboratorios/laboratorios.selectors';
import { selectAllDepositosFromCurrentEmpresa } from '../../../../actividades/entity-depositos/depositos.selectors';
import { selectAllSitiosProcesamientoFromCurrentEmpresa } from '../../../../actividades/entity-sitios-procesamiento/sitios-procesamiento.selectors';
import { selectAllMaquinaMovilCurrentEmpresa } from '../../../../actividades/entity-maquinas-moviles/entity-maquina-movil.selectors';
import { selectEntidadesProductivaFromCurrentEmpresa } from '../../../entity-entidad-productiva/entity-entidades-productiva.selectors';

@Component({
  selector: 'rpe-vista-mis-depositos-dependencias-container',
  templateUrl: './vista-mis-depositos-dependencias-container.component.html',
  styleUrls: ['./vista-mis-depositos-dependencias-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaMisDepositosDependenciasContainerComponent implements OnInit, OnDestroy {
  vistaMisDepositosDependencias: VistaMisDepositosDependenciasInput

  private subscription: Subscription

  constructor(
    private store: Store<State>,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.vistaMisDepositosDependencias = createVistaDepositosDependencias()

    this.subscription = combineLatest([
      this.store.select(selectEntidadesProductivaFromCurrentEmpresa),
      this.store.select(selectViverosGrupoEspecieCurrentEmpresa),
      this.store.select(selectAllLaboratoriosFromCurrentEmpresa),
      this.store.select(selectAllDepositosFromCurrentEmpresa),
      this.store.select(selectAllSitiosProcesamientoFromCurrentEmpresa),
      this.store.select(selectAllMaquinaMovilCurrentEmpresa)
    ]).pipe(
      tap(
        ([entidadProductiva, viveros, laboratorios, depositos, sitiosProcesamiento, maquinasMoviles]) => {
          this.vistaMisDepositosDependencias = {
            formInputViveros: viveros.map((vivero) => {
              return {
                vivero: vivero
              }
            }) as unknown as ViveroFormInput[],
            entidadProductiva: entidadProductiva,
            laboratorios: laboratorios,
            depositos: depositos,
            sitiosProcesamiento: sitiosProcesamiento,
            maquinasMoviles: maquinasMoviles
          }
          this.cdr.detectChanges()
        }
      ),
    ).subscribe()
    
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
